import { Space, Table, TableColumnProps, TableProps, Tag, Typography } from 'antd';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { RequestJobPostingCollection } from '../../types';
import {
  calculateOpenDays,
  getRequestJobPostingFinishedAt,
  isRequestJobPostingFinished,
} from '../../utils';

interface Props extends TableProps<RequestJobPostingCollection> {
  actionsRender: NonNullable<TableColumnProps<RequestJobPostingCollection>['render']>;
}

const RequestJobPostingTable: React.FC<Props> = ({ actionsRender, ...props }) => {
  const { t } = useTranslation();

  return (
    <Table rowKey="id" {...props}>
      <Table.Column
        title={t('Requisições')}
        render={(_value, record: RequestJobPostingCollection) => (
          <>
            <Space direction="horizontal">
              <Link to={`${record.id}`} className="ant-typography-link">
                {`${record.id} - ${record.name}`}
              </Link>
            </Space>
            <br />
            <Typography.Text type="secondary">
              <Trans>Dias em aberto</Trans>:{' '}
              {calculateOpenDays(record.created_at, getRequestJobPostingFinishedAt(record))}
            </Typography.Text>
          </>
        )}
      />
      <Table.Column
        title={t('Status das requisições')}
        align="center"
        render={(_, record: RequestJobPostingCollection) => (
          <>
            {record.status === 'IN_PROGRESS' && (
              <Tag color="processing">
                <Trans>Em andamento</Trans>
              </Tag>
            )}
            {record.status === 'NOT_INITIATED' && (
              <Tag color="default">
                <Trans>Não iniciada</Trans>
              </Tag>
            )}
            {record.status === 'CANCELED' && (
              <Tag color="default">
                <Trans>Cancelada</Trans>
              </Tag>
            )}
            {record.status === 'REJECTED' && (
              <Tag color="error">
                <Trans>Reprovada</Trans>
              </Tag>
            )}
            {record.status === 'APPROVED' && (
              <Tag color="success">
                <Trans>Aprovada</Trans>
              </Tag>
            )}
          </>
        )}
      />
      <Table.Column
        title={t('Modelo de requisição')}
        colSpan={1}
        align="center"
        dataIndex="id"
        render={(_value, record: RequestJobPostingCollection) => (
          <Typography.Text>{record.template_name}</Typography.Text>
        )}
      />
      <Table.Column
        title={t('Unidade')}
        colSpan={1}
        align="center"
        dataIndex="id"
        render={(_id, record: RequestJobPostingCollection) => (
          <Typography.Text>{record.branch || '-'}</Typography.Text>
        )}
      />
      <Table.Column
        title={t('Aprovação')}
        colSpan={1}
        align="center"
        render={(_value, record: RequestJobPostingCollection) => (
          <Typography.Text>
            {record.approved_stages_count}/{record.stages_count}
          </Typography.Text>
        )}
      />
      <Table.Column
        title={t('Aprovador pendente')}
        colSpan={1}
        align="center"
        render={(_value, record: RequestJobPostingCollection) => (
          <Typography.Text>
            {isRequestJobPostingFinished(record) || !record.pending_approver
              ? '-'
              : record.pending_approver}
          </Typography.Text>
        )}
      />
      <Table.Column
        title={t('Requisitante')}
        colSpan={1}
        align="center"
        dataIndex="id"
        render={(_id, record: RequestJobPostingCollection) =>
          record.claimant.is_staff ? (
            <Typography.Text>
              <Trans>Sistema</Trans>
            </Typography.Text>
          ) : (
            <Typography.Text>{record.claimant.full_name}</Typography.Text>
          )
        }
      />
      <Table.Column title={t('Ações')} align="center" render={actionsRender} />
    </Table>
  );
};
export default RequestJobPostingTable;
